import { render, staticRenderFns } from "./TagContent.vue?vue&type=template&id=dd0f8e46&scoped=true"
import script from "./TagContent.vue?vue&type=script&lang=js"
export * from "./TagContent.vue?vue&type=script&lang=js"
import style0 from "./TagContent.vue?vue&type=style&index=0&id=dd0f8e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f8e46",
  null
  
)

export default component.exports